// extracted by mini-css-extract-plugin
export default {"contain":"Card_contain__AGo+8","name":"Card_name__uBH0z","buttonClose":"Card_buttonClose__wCxDz"};